module.exports = __webpack_public_path__ + "static/media/Sevayo_Insights_Color.a8db8db9.png";